import { Button, HStack, Stack } from "@chakra-ui/react";
import { useCallback } from "react";
import useAudioRecorder from "../hooks/api/common/useAudioRecorder";
import { useTranslation } from "react-i18next";

type Props = {
  onChange: (base64: string, endTime: number) => void;
  isDisabled?: boolean;
};

export default function AudioRecorder({ onChange, isDisabled = false }: Props) {
  const { t } = useTranslation();

  const onNewAudio = useCallback(
    async (e: BlobEvent, duration: number) => {
      const reader = new FileReader();
      reader.readAsDataURL(e.data);
      reader.onloadend = () => {
        onChange(reader.result as string, duration);
      };
    },
    [onChange],
  );
  const { isRecording, startRecording, stopRecording } =
    useAudioRecorder(onNewAudio);

  const _startRecording = useCallback(() => {
    onChange("", 0);
    startRecording();
  }, [onChange, startRecording]);

  return (
    <Stack gap={4}>
      <HStack>
        <Button
          isDisabled={isRecording || isDisabled}
          onClick={_startRecording}
        >
          {t("common.buttons.start")}
        </Button>
        <Button isDisabled={!isRecording || isDisabled} onClick={stopRecording}>
          {t("common.buttons.stop")}
        </Button>
      </HStack>
    </Stack>
  );
}
